<template>
  <SignUp
    :email="email"
    :password="password"
    :first-name="firstName"
    :last-name="lastName"
    :errors="$v"
    :form-error="createUserError"
    :show-password="showPassword"
    :loading="creatingUser"
    :disable="sent || creatingUser"
    :terms-link="theme().defaultBrand?.legal?.termsAndConditionsLink"
    :privacy-policy-link="theme().defaultBrand?.legal?.privacyPolicyLink"
    @update:email="setEmail"
    @update:firstName="setFirstName"
    @update:lastName="setLastName"
    @update:password="password = $event"
    @update:showPassword="showPassword = $event"
    @logIn="logIn"
    @signUp="signUp"
  />
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import validations from './validations';
import { getEnv } from 'ecx.saigon.ui.common';

export default {
  name: 'SignUpWidget',
  validations,
  data() {
    return {
      showPassword: false,
      password: '',
      sent: false
    };
  },
  computed: {
    ...mapState({
      email: (state) => state.signUp.email,
      firstName: (state) => state.signUp.firstName,
      lastName: (state) => state.signUp.lastName,
      createUserError: (state) => state.signUp.createUserError,
      creatingUser: (state) => state.signUp.creatingUser
    }),
    ...mapGetters('user', ['theme'])
  },
  methods: {
    ...mapMutations('signUp', ['setEmail', 'setFirstName', 'setLastName']),
    ...mapActions('signUp', ['createUser']),
    async logIn() {
      this.$router.push({
        name: this.$auth.isAuthenticated
          ? this.$RouteNames.dashboard
          : this.$RouteNames.login
      });
    },
    async signUp() {
      this.$v.$touch();
      if (this.$v.$error) {
        return;
      }
      try {
        const response = await this.createUser(this.password);
        if (
          response.status === this.$Constants.CREATE_USER_STATUSES.emailVerified
        ) {
          return this.$router.push({
            name: this.$RouteNames.accountExists,
            query: {
              firstName: response.firstName,
              lastName: response.lastName
            }
          });
        }
        this.sent = true;
        if (response.validateEmailUrl) {
          return (window.location = response.validateEmailUrl);
        }
      } catch (error) {}
    }
  },
  async mounted() {
    const env = await getEnv();
    this.setEmail(this.$route.query.email || undefined);
    this.setFirstName(this.$route.query.firstname || undefined);
    this.setLastName(this.$route.query.lastname || undefined);
  },
  components: {
    SignUp: () => import('../../components/page/sign-up')
  }
};
</script>
